import { AdConfigServer } from '@schibsted-nmp/advertising-shared';

export function initiateGam(gamConfig: AdConfigServer['gam']) {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  window.googletag.enableServices();
  window.googletag.pubads().collapseEmptyDivs(true);
  window.googletag.pubads().enableSingleRequest();

  // Enable lazy loading
  window.googletag.pubads().disableInitialLoad();

  // Set global targeting
  if (gamConfig?.targeting) {
    gamConfig.targeting.forEach((target) => {
      window.googletag.pubads().setTargeting(target.key, target.value);
    });
  }

  console.log('Google Ad Manager initialised', window.googletag, gamConfig);
}
